import '@traceio-org/auth-ui/styles.css';
import '@traceio-org/ui/styles.css';
import './admin.css';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { AdminApp, RefusedPage } from './app';
import { loadAdminConfig } from './config';
import { createAdminDependencies } from './deps';

const container = document.getElementById('root');
if (!container) throw new Error('admin-web: #root is missing from index.html');

// The favicons (Obsidian mark on light browser chrome, Peel on dark) are linked in index.html; nothing is set
// here, so the per-scheme links are not overwritten with the Obsidian mark that dark tab bars hide.

const root = createRoot(container);
const result = loadAdminConfig(import.meta.env, { dev: import.meta.env.DEV });

if (!result.ok) {
  // A build with broken settings: the refusal page, never the gate and never a token request.
  console.error('admin-web: refused to start', result.errors);
  root.render(
    <StrictMode>
      <RefusedPage errors={result.errors} />
    </StrictMode>,
  );
} else {
  for (const warning of result.warnings) console.warn(`admin-web: ${warning}`);
  root.render(
    <StrictMode>
      <AdminApp config={result.config} deps={createAdminDependencies(result.config)} />
    </StrictMode>,
  );
}
